export const useState = (): UserState => {
  return {
    netId: null,
    serviceTicket: null,
    agencyId: '',
    agentLogin: null,
    agentName: null,
    agentEmail: null,
    agentId: null,
    agencyName: null,
    agencyEmail: null,
    agencyPhone: null,
    agencyCountry: null,
    expiCode: null,
    pdfWithAgencyInformation: true,
    hideExpinetLeaveWarningArray: []
  }
}

export interface UserState {
  netId: string | null, // TODO: check if just string will also do the trick
  serviceTicket: string | null, // TODO: check if just string will also do the trick
  agencyId: string,
  agentLogin: string | null, // TODO: check if just string will also do the trick
  agentName: string | null, // TODO: check if just string will also do the trick
  agentEmail: string | null, // TODO: check if just string will also do the trick
  agentId: string | null, // TODO: check if just string will also do the trick
  agencyName: string | null, // TODO: check if just string will also do the trick
  agencyEmail: string | null, // TODO: check if just string will also do the trick
  agencyPhone: string | null, // TODO: check if just string will also do the trick
  agencyCountry: string | null, // TODO: check if just string will also do the trick
  expiCode: string | null, // TODO: check if just string will also do the trick
  pdfWithAgencyInformation: boolean,
  hideExpinetLeaveWarningArray: string[]
}